import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=254c6e72&scoped=true&"
import script from "./CollectionView.vue?vue&type=script&lang=ts&"
export * from "./CollectionView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionView.vue?vue&type=style&index=0&id=254c6e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c6e72",
  null
  
)

export default component.exports